import React, { Component } from "react";
import { matchPath, Redirect, Route, Router, Switch } from "react-router-dom";
import "./App.scss";
import "../styles/sharedStyles.scss";
import PreviewTermsConditions from "../shared/previewTermsConditions/PreviewTermsConditions";
import TermsDeclined from "../components/declineTerms/TermsDeclined";
import Dealer from "./pure/Dealer";
import Help from "../components/help/help";
import CustomerReservations from "../components/customerReservation/CustomerReservations";
import GlobalNavBar from "../shared/globalNavBar/GlobalNavBar";
import Footer from "../shared/Footer/Footer";
import QuickStart from "../components/quickStart/QuickStart";
import ProgressBarTabs from "../components/progressBar/ProgressBarTabs";
import AccessDeniedAsBevDisabled from "../components/accessDenied/AccessDeniedAsBevDisabled";
import AccessDeniedAsNotOnBoarded from "../components/accessDenied/AccessDeniedAsNotOnBoarded";
import InvalidRoute from "../components/accessDenied/InvalidRoute";
import BusinessSettings from "../components/businessSetting/BusinessSettings";
import DealerDashboard from "../components/dashboard/dealerDashBoard/DealerDashboard";
import { logMsg } from "../common/Logger";
import withIdleTimer from "../common/WithIdleTimer";
import PricingWrapper from "../components/pricing/pricingWrapper/PricingWrapper";
import DealerCurrentPricing from "../components/pricing/pricingWrapper/currentPricing/DealerCurrentPricing";
import DealerFuturePricing from "../components/pricing/pricingWrapper/currentPricing/DealerFuturePricing";
import HasPermissionTo from "../common/HasPermissionTo";
import DealerOnboardingClient from "../shared/clients/DealerOnboardingClient";
import LocalizedInfoClient from "../shared/clients/LocalizedInfoClient";
import DealerGroupingClient from "../shared/clients/DealerGroupingClient";
import PendingActionClient from "../shared/clients/PendingActionClient";
import ErrorScreen from "../errors/ErrorScreen";
import OrderDetailsNewVersion from "../components/customerOrderDetail/orderDetailsNewVersion/OrderDetailsNewVersion";
import AccessoriesPricingWrapper from "../components/pricing/pricingWrapper/accessoriesPricing/AccessoriesPricingWrapper";
import AccessDeniedAsNscNotOnboarded from "../components/accessDenied/AccessDeniedAsNscNotOnboarded";
import {
  IS_BELGIUM_MARKET,
  IS_BRITAIN_MARKET,
  IS_SWISS_MARKET,
} from "../utils/EmpUtil";
import {
  CUSTOMER_CONTRACT,
  DELIVERY_BANDS,
  OPT_IN,
  RESERVATION_DEPOSIT,
  STORE_ID,
  TERMS_AND_CONDITIONS,
} from "../common/Constants";
import { withTranslation } from "react-i18next";
import ModifyReservationPrice from "../components/pricing/pricingWrapper/depositPricing/modifyReservationPrice/ModifyReservationPrice";

class DealerApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      renderApp: false,
      shouldNavigationBeRestricted: false,
      dealerGroup: [],
      dealerGroupFiltered: [],
      currentDealer: new Dealer(
        this.props.token,
        this.props.userDetails,
        this.props.history
      ),
      padding: "70px",
    };
    this.localizedInfo = {};
    this.lang = undefined;

    // Listening for route change
    this.props.history.listen(() => this.setNavigationRestriction());

    this.dealerChanged = this.dealerChanged.bind(this);
    this.navigateToRoute = this.navigateToRoute.bind(this);
    this.getPendingActions = this.getPendingActions.bind(this);
    this.onReservationSave = this.onReservationSave.bind(this);
    this.onDecline = this.onDecline.bind(this);
  }

  componentDidMount() {
    this.getLocalizedInfo();
  }

  onDealerDecline() {
    this.onBoardingStatus = "PENDING";
    this.navigateToRoute("");
  }

  onReservationSave() {
    this.onBoardingStatus = "ACCEPTED";
    window.location.href = "/";
  }

  onDecline() {
    this.onBoardingStatus = "DECLINED";
    this.navigateToRoute("declined");
  }

  getLocalizedInfo() {
    const market = this.props.userDetails.market;
    LocalizedInfoClient.getLocalizedInfo(this.state.currentDealer, market)
      .then((response) => {
        this.localizedInfo = Object.assign(
          {},
          { ...this.localizedInfo },
          { ...response }
        );
        if (!IS_SWISS_MARKET(market) && !IS_BELGIUM_MARKET(market)) {
          this.lang = this.localizedInfo.defaultLanguage.isocode;

          this.props.i18n.changeLanguage(
            this.lang.substring(0, 2) + "_" + this.props.userDetails.market
          );
        }
      })
      .catch((error) => logMsg("the error is: ", error))
      .finally(() => {
        this.hasNscOnboarded();
      });
  }

  isBevEnabledAndOnboarded() {
    this.props.hideOrShow(true);
    const market = this.props.userDetails.market;
    const isSuperGroupUser = this.props.userDetails.superGroupUser;

    DealerGroupingClient.getDealerGroup(
      this.state.currentDealer,
      market,
      isSuperGroupUser
    )
      .then((data) => {
        let dealer;
        if (data.length > 1) {
          dealer = data.filter(
            (dealer) =>
              dealer.dealerType === "MDLR" || dealer.dealerType === "HUB"
          )[0];
        } else {
          dealer = data[0];
        }
        const market = this.props.userDetails.market;
        if (IS_SWISS_MARKET(market)) {
          if (dealer.language === "D") {
            this.lang = "de_CH";
          } else if (dealer.language === "F" || dealer.language === "I") {
            this.lang = "fr_CH";
          } else {
            this.lang = "de_CH";
          }
          this.props.i18n.changeLanguage(
            this.lang.substr(0, 2) + "_" + this.props.userDetails.market
          );
        } else if (IS_BELGIUM_MARKET(market)) {
          this.lang = dealer.language === "N" ? "nl_BE" : "fr_BE";
          this.props.i18n.changeLanguage(
            this.lang.substr(0, 2) + "_" + this.props.userDetails.market
          );
        }
        //New logic as we are checking whether the access control has the active vehicle lines from EMP
        this.canSeeDashboard = dealer.hasAccessControlContainsActive;

        if (!this.canSeeDashboard) {
          this.navigateToRoute("denied");
        } else {
          const bevAndIceDealers = data.sort((a, b) => {
            if (a.dealerType === "MDLR" || a.dealerType === "HUB") {
              return -1;
            } else if (b.dealerType === "MDLR" || b.dealerType === "HUB") {
              return 1;
            } else {
              return 0;
            }
          });

          dealer.dealerType === "MDLR" || dealer.dealerType === "HUB"
            ? this.setState({
                dealerGroup: IS_BRITAIN_MARKET(market)
                  ? bevAndIceDealers.filter(
                      (dealer) => dealer.dealerType !== "SDLR"
                    )
                  : bevAndIceDealers,
                dealerGroupFiltered: bevAndIceDealers.filter(
                  (dealer) => dealer.dealerType !== "SDLR"
                ),
              })
            : this.setState({
                dealerGroup: bevAndIceDealers,
                dealerGroupFiltered: this.state.dealerGroup,
              });

          this.state.currentDealer.setDealerGroup(this.state.dealerGroup);
          this.updateCurrentDealer(dealer, true);
          this.onBoardingStatus = dealer.onBoardingStatus;
          this.dealerActiveStatus = dealer.dealerActiveStatus;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.canSeeDashboard
          ? this.determinePendingActionStatuses()
          : this.performFinalActions.call(this);
      });
  }

  determinePendingActionStatuses() {
    const market = this.props.userDetails.market;
    PendingActionClient.getHasNscCompletedPA(
      this.state.currentDealer,
      1,
      market
    )
      .then((hasNscCompletedBasicPAs) => {
        const currentDealer = this.state.currentDealer;
        currentDealer.hasNscCompletedBasicPAs = hasNscCompletedBasicPAs;
        this.setState({ currentDealer });
      })
      .finally(() => {
        this.getPendingActions().finally(() =>
          this.performFinalActions.call(this)
        );
      });
  }

  hasNscOnboarded() {
    PendingActionClient.getHasNscCompletedPA(
      this.state.currentDealer,
      0,
      this.props.userDetails.market
    ).then((hasNscOnboarded) => {
      if (hasNscOnboarded) {
        this.isBevEnabledAndOnboarded();
      } else {
        this.onBoardingStatus = "NSC_NOT_ONBOARDED";
        this.navigateToRoute("nsc-not-onboarded");
        this.performFinalActions.call(this);
      }
    });
  }

  performFinalActions() {
    this.setNavigationRestriction();
    this.props.hideOrShow(false);
    this.setState({ renderApp: true });
  }

  setNavigationRestriction() {
    if (this.onBoardingStatus !== "ACCEPTED") {
      this.setState({ shouldNavigationBeRestricted: true });
    } else {
      const isAllowedPath = this.isCurrentPathAllowedToShowHeaderAndFooter(
        this.props.history.location.pathname
      );
      this.setState({ shouldNavigationBeRestricted: !isAllowedPath });
    }
  }

  isCurrentPathAllowedToShowHeaderAndFooter(currentPathName) {
    const paths = [
      "/help",
      "/dealer/customer-reservations",
      "/business-settings",
      "/dashboard",
      "/pricing/deposit",
      "/pricing",
      "/",
    ];

    if (this.state.currentDealer.hasNscCompletedBasicPAs) {
      paths.push("/pricing/accessories");
      paths.push("/pricing/vehicles");
      paths.push("/pricing/future");
    }

    if (paths.includes(currentPathName)) {
      return true;
    } else {
      const allowedCustomerReservation = matchPath(currentPathName, {
        path: `/dealer/:commonId/customer-reservations/order-details/:id`,
      });
      return !!allowedCustomerReservation;
    }
  }

  navigateToRoute(link) {
    this.props.history.push(`/${link}`);
  }

  updateDealerPhoneAndEmail(dealer, email, phone) {
    const index = this.state.dealerGroup.indexOf(
      this.state.dealerGroup.filter(
        (d) => d.completeDealerId === dealer.dealerId
      )[0]
    );

    const dealerGroupCopy = JSON.parse(JSON.stringify(this.state.dealerGroup));
    dealerGroupCopy[index].emailAddress = email;
    dealerGroupCopy[index].phoneNumber = phone;

    this.setState({ dealerGroup: dealerGroupCopy });
  }

  updateDealerEmpMembership(dealer) {
    const index = this.state.dealerGroup.indexOf(
      this.state.dealerGroup.filter(
        (d) => d.completeDealerId === dealer.completeDealerId
      )[0]
    );

    const dealerGroup = this.state.dealerGroup;
    dealerGroup[index].status = dealer.status;

    this.setState({ dealerGroup });
  }

  isMainViewingSDLR = (dealer) => {
    // Returns true if a main dealer is currently viewing an SDLR
    return (
      this.state.currentDealer.isLoggedInUserMDLR &&
      dealer.dealerType === "SDLR"
    );
  };

  async getPendingActions(
    dealer = this.state.currentDealer,
    updatePAOnly = true
  ) {
    this.props.hideOrShow(true);
    const marketId = this.state.currentDealer.market;
    await PendingActionClient.getDealerPendingActionsNotifications(
      dealer,
      marketId
    )
      .then((data) => {
        !this.state.currentDealer.dealersNotFullyOnboarded &&
          this.setPartiallyOnboardedDealers(data.pendingActions, dealer);
        !this.state.currentDealer.toggleDisabledDealers &&
          this.setToggleDisabledDealers(data.pendingActions);
        if (updatePAOnly) {
          this.state.currentDealer.updatePendingActions(data.pendingActions);
        } else {
          this.setState({ currentDealer: dealer }, () => {
            this.state.currentDealer.updatePendingActions(data.pendingActions);
          });
        }
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  updateCurrentDealer(dealer, showAll = false, getPendingActions = false) {
    const newDealer = this.state.currentDealer.updateCurrentDealer(
      dealer,
      showAll
    );
    const hasPendingActionPermission =
      this.state.currentDealer.permissions.rolePermissions.hasOwnProperty([
        "pendingActionQueue:view",
      ]);
    if (getPendingActions && hasPendingActionPermission) {
      this.getPendingActions(newDealer, false);
    } else {
      this.setState({ currentDealer: newDealer });
    }
  }

  dealerChanged(dealer, showAll = false) {
    this.updateCurrentDealer(dealer, showAll, true);
  }

  setPadding = (padding) => {
    if (padding > 70) {
      this.setState({ padding: padding + "px" });
    }
  };

  getProgressBarTabs() {
    return ProgressBarTabs().onboardingDealer;
  }

  setPartiallyOnboardedDealers(pendingActions) {
    if (pendingActions) {
      const dealerList = {};

      const filteredTCPendingActions = pendingActions.filter(
        (pendingAction) => pendingAction.actionName === TERMS_AND_CONDITIONS
      );

      let TCDealers = [];
      if (filteredTCPendingActions.length > 0) {
        filteredTCPendingActions.forEach((pendingAction) => {
          const dealers =
            pendingAction.attributes &&
            pendingAction.attributes.dealerIds &&
            pendingAction.attributes.dealerIds;
          TCDealers = TCDealers.concat(dealers);
        });
      }

      dealerList[TERMS_AND_CONDITIONS] = TCDealers;

      const filteredRDPendingActions = pendingActions.filter(
        (pendingAction) => pendingAction.actionName === RESERVATION_DEPOSIT
      );

      let RDDealers = [];
      if (filteredRDPendingActions.length > 0) {
        filteredRDPendingActions.forEach((pendingAction) => {
          if (
            pendingAction.attributes &&
            pendingAction.attributes.vehicleLines
          ) {
            pendingAction.attributes.vehicleLines.length > 0 &&
              pendingAction.attributes.vehicleLines.forEach((vehicleLine) => {
                const dealers = vehicleLine.dealerInfoList
                  .filter((x) => x.dealerId)
                  .map((x) => x.dealerId);
                RDDealers = RDDealers.concat(dealers);
              });
          } else {
            const dealers =
              pendingAction.attributes &&
              pendingAction.attributes.dealerIds &&
              pendingAction.attributes.dealerIds;
            RDDealers = RDDealers.concat(dealers);
          }
        });
      }

      dealerList[RESERVATION_DEPOSIT] = RDDealers;

      const filteredOptInActions = pendingActions.filter(
        (pendingAction) => pendingAction.actionName === OPT_IN
      );

      let OptInDealers = [];
      if (filteredOptInActions.length > 0) {
        filteredOptInActions.forEach((pendingAction) => {
          const dealers =
            pendingAction.attributes &&
            pendingAction.attributes.dealerIds &&
            pendingAction.attributes.dealerIds;
          OptInDealers = OptInDealers.concat(dealers);
        });
      }

      dealerList[OPT_IN] = OptInDealers;

      const currentUserState = this.state.currentDealer;
      currentUserState.dealersNotFullyOnboarded = dealerList;

      this.setState({
        currentDealer: currentUserState,
      });
    }
  }

  setToggleDisabledDealers(pendingActions) {
    const REQUIRED_PENDING_ACTIONS = [
      TERMS_AND_CONDITIONS,
      STORE_ID,
      CUSTOMER_CONTRACT,
      DELIVERY_BANDS,
      OPT_IN,
    ];

    const toggleDisabledDealers = {};

    pendingActions &&
      pendingActions.forEach((action) => {
        if (action) {
          if (action.actionName === RESERVATION_DEPOSIT) {
            toggleDisabledDealers[RESERVATION_DEPOSIT] =
              this.getReservationDealers(action.attributes);
          }
          if (REQUIRED_PENDING_ACTIONS.includes(action.actionName)) {
            toggleDisabledDealers[action.actionName] =
              action.attributes && action.attributes.dealerIds;
          }
        }
      });

    const currentUserState = this.state.currentDealer;
    currentUserState.toggleDisabledDealers = toggleDisabledDealers;

    this.setState({
      currentDealer: currentUserState,
    });
  }

  getReservationDealers = (action) => {
    let dealers = [];
    if (action && action.vehicleLines) {
      action.vehicleLines.forEach((vehicleLine) => {
        dealers = dealers.concat(
          vehicleLine &&
            vehicleLine.dealerInfoList &&
            vehicleLine.dealerInfoList.map(function (dealers) {
              return dealers.dealerId;
            })
        );
      });
    }
    return dealers;
  };

  render() {
    const ProtectedRoute = ({
      component: Component,
      perform: perform,
      ...rest
    }) => (
      <HasPermissionTo
        perform={perform}
        permissions={this.state.currentDealer.permissions.rolePermissions}
        render={() => (
          <Route
            {...rest}
            render={(props) =>
              this.onBoardingStatus === "ACCEPTED" ? (
                <Component
                  {...rest.customprops}
                  {...this.props}
                  {...props.match.params}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />
        )}
      />
    );

    const DeclinedRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={() =>
          this.onBoardingStatus === "DECLINED" ? (
            <Component {...rest.customprops} {...this.props} />
          ) : (
            <Redirect to="/" />
          )
        }
      />
    );

    return this.state.renderApp ? (
      <Router history={this.props.history}>
        <div className="appWrapper" id="appWrapper">
          {this.state.shouldNavigationBeRestricted ? null : (
            <div style={{ paddingTop: this.state.padding }}>
              <GlobalNavBar
                {...this.props}
                dealerGroup={this.state.dealerGroup}
                onDealerChanged={this.dealerChanged}
                user={this.state.currentDealer}
                urlPath={window.location.pathname}
                setPadding={this.setPadding}
                navigateToRoute={this.navigateToRoute}
              />
            </div>
          )}
          <Switch>
            <ProtectedRoute
              exact
              path="/dashboard"
              component={withIdleTimer(DealerDashboard)}
              perform={["dashBoardPage"]}
              customprops={{
                user: this.state.currentDealer,
                isMainViewingSDLR: this.isMainViewingSDLR,
                onDealerChanged: this.dealerChanged.bind(this),
                lang: this.lang,
              }}
            />
            <ProtectedRoute
              exact
              path="/pricing"
              component={withIdleTimer(PricingWrapper)}
              perform={["pricingPage"]}
              customprops={{
                user: this.state.currentDealer,
                isMainViewingSDLR: this.isMainViewingSDLR,
                localizedInfo: this.localizedInfo,
                onDealerChanged: this.dealerChanged.bind(this),
              }}
            />
            <ProtectedRoute
              exact
              path="/dealer/:commonId/customer-reservations/order-details/:reservationId"
              component={withIdleTimer(OrderDetailsNewVersion)}
              perform={["ordersPage"]}
              customprops={{
                user: this.state.currentDealer,
                lang: this.lang,
                localizedInfo: this.localizedInfo,
                onDealerChanged: this.dealerChanged.bind(this),
              }}
            />
            <ProtectedRoute
              exact
              path="/dealer/customer-reservations"
              component={withIdleTimer(CustomerReservations)}
              perform={["ordersPage"]}
              customprops={{
                user: this.state.currentDealer,
                lang: this.lang,
                onDealerChanged: this.dealerChanged.bind(this),
                fromNscDealerSearch: this.props.fromNscDealerSearch,
              }}
            />
            <ProtectedRoute
              exact
              path="/business-settings"
              component={withIdleTimer(BusinessSettings)}
              perform={["businessSettingsPage"]}
              customprops={{
                isMainViewingSDLR: this.isMainViewingSDLR,
                getPendingActions: this.getPendingActions.bind(this),
                user: this.state.currentDealer,
                lang: this.lang,
                dealerGroup: this.state.dealerGroup,
                localizedInfo: this.localizedInfo,
                updateDealerPhoneAndEmail:
                  this.updateDealerPhoneAndEmail.bind(this),
                updateDealerEmpMembership:
                  this.updateDealerEmpMembership.bind(this),
                onDealerChanged: this.dealerChanged.bind(this),
                permissions: this.props.userDetails.permissions,
              }}
            />
            <Route
              exact
              path="/help"
              component={withIdleTimer(() => (
                <Help
                  {...this.props}
                  market={this.state.currentDealer.market}
                />
              ))}
            />
            <DeclinedRoute
              exact
              path="/declined"
              component={withIdleTimer(TermsDeclined)}
              customprops={{
                user: this.state.currentDealer,
                onDecline: this.onDealerDecline.bind(this),
              }}
            />
            <ProtectedRoute
              exact
              path="/pricing/deposit"
              perform={["depositPricingTab"]}
              component={withIdleTimer(() => (
                <ModifyReservationPrice
                  {...this.props}
                  localizedInfo={this.localizedInfo}
                  user={this.state.currentDealer}
                  isMainViewingSDLR={this.isMainViewingSDLR}
                  onDealerChanged={this.dealerChanged}
                  getPendingActions={this.getPendingActions}
                />
              ))}
            />
            {this.state.currentDealer.hasNscCompletedBasicPAs && (
              <ProtectedRoute
                exact
                path="/pricing/vehicles"
                perform={["vehiclePricingTab"]}
                component={withIdleTimer(() => (
                  <DealerCurrentPricing
                    {...this.props}
                    user={this.state.currentDealer}
                    getPendingActions={this.getPendingActions}
                    localizedInfo={this.localizedInfo}
                    isMainViewingSDLR={this.isMainViewingSDLR}
                    onDealerChanged={this.dealerChanged}
                    lang={this.lang}
                  />
                ))}
              />
            )}
            {this.state.currentDealer.hasNscCompletedBasicPAs && (
              <ProtectedRoute
                exact
                path="/pricing/future"
                perform={["futurePricingTab"]}
                component={withIdleTimer(() => (
                  <DealerFuturePricing
                    {...this.props}
                    user={this.state.currentDealer}
                    getPendingActions={this.getPendingActions}
                    localizedInfo={this.localizedInfo}
                    isMainViewingSDLR={this.isMainViewingSDLR}
                    onDealerChanged={this.dealerChanged}
                    lang={this.lang}
                  />
                ))}
              />
            )}

            {this.state.currentDealer.hasNscCompletedBasicPAs && (
              <ProtectedRoute
                exact
                path="/pricing/accessories"
                perform={["accessoriesPricingTab"]}
                component={withIdleTimer(() => (
                  <AccessoriesPricingWrapper
                    {...this.props}
                    localizedInfo={this.localizedInfo}
                    user={this.state.currentDealer}
                    isMainViewingSDLR={this.isMainViewingSDLR}
                    onDealerChanged={this.dealerChanged}
                    getPendingActions={this.getPendingActions}
                    lang={this.lang}
                  />
                ))}
              />
            )}

            <Route exact path="/denied" component={AccessDeniedAsBevDisabled} />
            <Route
              exact
              path="/notonboarded"
              component={AccessDeniedAsNotOnBoarded}
            />
            <Route
              exact
              path="/nsc-not-onboarded"
              component={AccessDeniedAsNscNotOnboarded}
            />
            <Route
              exact
              path="/"
              render={() =>
                this.onBoardingStatus === "ACCEPTED" ||
                (this.onBoardingStatus === "DECLINED" &&
                  this.dealerActiveStatus === "IN_ACTIVE") ? (
                  <Redirect
                    to={{
                      pathname: "/dashboard",
                    }}
                  />
                ) : this.onBoardingStatus === "DECLINED" ? (
                  <Redirect
                    to={{
                      pathname: "/declined",
                    }}
                  />
                ) : // NOTE: ONBOARDINGNOTCOMPLETED = means that this dealer cannot onboard self
                this.onBoardingStatus === "ONBOARDINGNOTCOMPLETED" ? (
                  <Redirect
                    to={{
                      pathname: "/notonboarded",
                    }}
                  />
                ) : (
                  this.onBoardingStatus === "PENDING" && (
                    <QuickStart
                      {...this.props}
                      user={this.state.currentDealer}
                      isMainViewingSDLR={this.isMainViewingSDLR}
                      dealerGroup={this.state.dealerGroupFiltered}
                      history={this.props.history}
                      onboardingClient={DealerOnboardingClient}
                      localizedInfo={this.localizedInfo}
                      onSave={this.onReservationSave}
                      onDecline={this.onDecline}
                      progressBarTabs={this.getProgressBarTabs()}
                      Preview={PreviewTermsConditions}
                      fromQuickstart={true}
                    />
                  )
                )
              }
            />
            <Route
              exact
              path="/error"
              render={(props) => <ErrorScreen {...props} />}
            />
            <Route component={withIdleTimer(InvalidRoute)} />
          </Switch>
          {this.state.shouldNavigationBeRestricted ? null : (
            <Footer
              isDealer={true}
              fromNscDealerSearch={this.props.fromNscDealerSearch}
              footerTitle={this.props.t("Footer.title")}
              helpSupportTitle={this.props.t("Footer.help")}
              permissions={this.props.userDetails.permissions}
            />
          )}
        </div>
      </Router>
    ) : null;
  }
}

export default withTranslation("emp")(DealerApp);
